import { Link } from 'react-router-dom';
import BrandMark from '../BrandMark';
import Icon from '../Icon';
import { useI18n } from '../../i18n/I18nContext';
import { useOwnerContact } from '../../hooks/useData';
import { buildWhatsappHref } from '../../lib/property';
import { MOLINO } from '../../config/molino';

function SiteFooter() {
  const { t } = useI18n();
  const owner = useOwnerContact();
  const waHref = buildWhatsappHref(owner.ownerWhatsapp, t.waGeneralMessage);
  const shareUrl = encodeURIComponent(window.location.origin);

  function handleBackTop(event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <footer className="site-footer">
      <div className="container site-footer__top">
        <div className="site-footer__brand">
          <BrandMark className="brand--large" />
          <p>{t.footerStatement}</p>
        </div>
        {waHref ? (
          <a className="site-footer__cta" href={waHref} target="_blank" rel="noreferrer">
            <span className="eyebrow">{t.ctaEyebrow}</span>
            <span className="site-footer__cta-text">
              {t.navCta}
              <Icon name="arrowUpRight" size={28} strokeWidth={1.2} />
            </span>
          </a>
        ) : null}
      </div>

      <div className="container site-footer__grid">
        <nav aria-label={t.footerSectionExplore}>
          <p className="site-footer__title">{t.footerSectionExplore}</p>
          <ul>
            <li><Link className="link-underline" to="/">{t.navHome}</Link></li>
            <li><Link className="link-underline" to="/terrenos">{t.landTitle}</Link></li>
            <li><Link className="link-underline" to={MOLINO.path}>{MOLINO.name}</Link></li>
            <li><Link className="link-underline" to="/propiedades">{t.navProperties}</Link></li>
            <li><Link className="link-underline" to="/comprar">{t.footerBuyLink}</Link></li>
            <li><Link className="link-underline" to="/alquilar">{t.footerRentLink}</Link></li>
            <li><Link className="link-underline" to="/#vender">{t.footerSell}</Link></li>
          </ul>
        </nav>

        <nav aria-label={t.footerSectionCompany}>
          <p className="site-footer__title">{t.footerSectionCompany}</p>
          <ul>
            <li><Link className="link-underline" to="/quienes-somos">{t.footerAbout}</Link></li>
            <li><Link className="link-underline" to="/contacto">{t.navContact}</Link></li>
            <li><Link className="link-underline" to="/politica-de-privacidad">{t.footerPrivacy}</Link></li>
            <li><Link className="link-underline" to="/terminos-y-condiciones">{t.footerTerms}</Link></li>
          </ul>
        </nav>

        <div>
          <p className="site-footer__title">{t.footerSectionContact}</p>
          <ul>
            {waHref ? (
              <li><a className="link-underline" href={waHref} target="_blank" rel="noreferrer">WhatsApp</a></li>
            ) : null}
            {owner.ownerPhone ? (
              <li><a className="link-underline" href={`tel:${owner.ownerPhone}`}>{owner.ownerPhone}</a></li>
            ) : null}
            {owner.ownerEmail ? (
              <li><a className="link-underline" href={`mailto:${owner.ownerEmail}`}>{t.ctaEmail}</a></li>
            ) : null}
            <li><span>{t.footerCity}</span></li>
          </ul>
        </div>

        <div>
          <p className="site-footer__title">{t.footerShareTitle}</p>
          <ul>
            <li>
              <a className="link-underline" href={`https://wa.me/?text=${shareUrl}`} target="_blank" rel="noreferrer">WhatsApp</a>
            </li>
            <li>
              <a className="link-underline" href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`} target="_blank" rel="noreferrer">Facebook</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container site-footer__bottom">
        <p>© {new Date().getFullYear()} {t.footerCopy}</p>
        <a href="#top" className="link-underline" onClick={handleBackTop}>{t.footerBackTop} ↑</a>
      </div>
    </footer>
  );
}

export default SiteFooter;
